<template>
  <div class="error-container">
    <p class="error-container__message">
      {{ message }}
    </p>
  </div>
</template>

<script>
export default {
  name: "ErrorLegend",
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.error-container {
  height: 56px;
  background-color: #fcefef;

  position: relative;
  display: table;
  width: 100%;
}
.error-container__message {
  height: 24px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #d4231a;

  display: table-cell;
  vertical-align: middle;

  padding-left: 40px;
}
</style>
